import './index.css';
import { useState, useLayoutEffect } from 'react';

var styles = {"item-animation-timeout":"magritte-item-animation-timeout___Pdli9_4-6-28","itemAnimationTimeout":"magritte-item-animation-timeout___Pdli9_4-6-28","fade-in":"magritte-fade-in___FDoho_4-6-28","fadeIn":"magritte-fade-in___FDoho_4-6-28"};

const useAnimationTimeout = () => {
    const [animationTimeout, setAnimationTimeout] = useState(0);
    useLayoutEffect(() => {
        const animationTimeoutElement = document.createElement('div');
        animationTimeoutElement.classList.add(styles.itemAnimationTimeout);
        document.body.appendChild(animationTimeoutElement);
        const style = window.getComputedStyle(animationTimeoutElement);
        const animationTimeout = parseInt(style.getPropertyValue(`--animation-duration`), 10);
        if (Number.isInteger(animationTimeout)) {
            setAnimationTimeout(animationTimeout);
        }
        document.body.removeChild(animationTimeoutElement);
    }, []);
    return { animationTimeout };
};

export { useAnimationTimeout };
//# sourceMappingURL=useAnimationTimeout.js.map
